import React from 'react';
import {isVideo, Video} from "./Video";

export const Content = (props: {url: string}) => isVideo(props.url) ?
	<Video url={props.url}/> :
	<img src={props.url} alt={"Content"}/>;
